// Registry kepemilikan document.title.
//
// RootLayout memasang effect global yang men-set document.title dari app-config
// (nama_ai + appDescription) setiap config berubah. Karena effect parent (RootLayout)
// selalu jalan SETELAH effect child (halaman) di React, sebuah halaman yang men-set
// judulnya sendiri saat mount akan tertimpa saat config resolve (mis. hard-load
// halaman statis seperti /privasi). Registry ini memberi halaman cara untuk "mengklaim"
// judul agar RootLayout tidak menimpanya.

/** Judul default platform saat tidak ada halaman yang mengklaim judul sendiri. */
export const DEFAULT_DOCUMENT_TITLE = 'Desa Platform — Asisten Digital Desa'

let owners = 0

/**
 * Klaim kepemilikan document.title oleh sebuah halaman. Panggil saat mount dan
 * jalankan fungsi rilis yang dikembalikan saat unmount.
 */
export function claimDocumentTitle(): () => void {
  owners += 1
  return () => {
    owners = Math.max(0, owners - 1)
  }
}

/** True jika ada halaman yang sedang mengelola document.title-nya sendiri. */
export function isDocumentTitleClaimed(): boolean {
  return owners > 0
}
